// 월요일 스케쥴

import { getWeekDates } from "../../modules/getWeekData";
// 현재의 날짜를 기준으로 한주의 배열을 추출한 후 해당 요엘의 데이터로 데이터셋

    // 한주의 모든 날짜를 현재 날짜를 기준으로 생성함
    let weekArr: string[] = [];
    const weekDates = getWeekDates();
    weekDates.forEach((day, index) => {
        weekArr.push(day);
    });

    // 각각의 요일에 대한 클래스들을 관리함
    const mon_class = [
        { 
            title: '초등부 (1학년)',
            startDate: `${weekArr[1].slice(0, 10)}T14:00`, 
            endDate: `${weekArr[1].slice(0, 10)}T15:00`, 
            type: 'elementry_low',
        },
        { 
            title: '초등부 (2, 3학년)',
            startDate: `${weekArr[1].slice(0, 10)}T15:00`, 
            endDate: `${weekArr[1].slice(0, 10)}T16:00`, 
            type: 'elementry_low',
        },
        { 
            title: '유치부(6, 7세)',
            startDate: `${weekArr[1].slice(0, 10)}T16:00`, 
            endDate: `${weekArr[1].slice(0, 10)}T17:00`, 
            type: 'kids',
        },
        // { 
        //     title: '유치부(7세)',
        //     startDate: `${weekArr[1].slice(0, 10)}T17:00`, 
        //     endDate: `${weekArr[1].slice(0, 10)}T18:00`,
        // },
        { 
            title: '선수반 | 대표반',
            startDate: `${weekArr[1].slice(0, 10)}T17:00`, 
            endDate: `${weekArr[1].slice(0, 10)}T20:00`, 
            type: 'athelet',
        },
    ];

    const tue_class = [
    
        { 
        title: '초등부 (1학년)',
        startDate: `${weekArr[2].slice(0, 10)}T14:00`, 
        endDate: `${weekArr[2].slice(0, 10)}T15:00`, 
        type: 'elementry_low',
        },
        { 
        title: '초등부 (2, 3학년)',
        startDate: `${weekArr[2].slice(0, 10)}T15:00`, 
        endDate: `${weekArr[2].slice(0, 10)}T16:00`, 
        type: 'elementry_low',
        },
        { 
        title: '유치부(6, 7세)',
        startDate: `${weekArr[2].slice(0, 10)}T16:00`, 
        endDate: `${weekArr[2].slice(0, 10)}T17:00`, 
        type: 'kids',
        },
        { 
        title: '유치부(7세)',
        startDate: `${weekArr[2].slice(0, 10)}T17:00`, 
        endDate: `${weekArr[2].slice(0, 10)}T18:00`, 
        type: 'kids',
        },
        { 
        title: '선수반 | 대표반',
        startDate: `${weekArr[2].slice(0, 10)}T17:00`, 
        endDate: `${weekArr[2].slice(0, 10)}T19:00`,
        type: 'athelet',
        },
        ];

    const wed_class = [
        { 
            title: '초등부 (1학년)',
            startDate: `${weekArr[3].slice(0, 10)}T14:00`, 
            endDate: `${weekArr[3].slice(0, 10)}T15:00`, 
            type: 'elementry_low',
        },
        { 
            title: '초등부 (2, 3학년)',
            startDate: `${weekArr[3].slice(0, 10)}T15:00`, 
            endDate: `${weekArr[3].slice(0, 10)}T16:00`, 
            type: 'elementry_low',
        },
        { 
            title: '유치부(6, 7세)',
            startDate: `${weekArr[3].slice(0, 10)}T16:00`, 
            endDate: `${weekArr[3].slice(0, 10)}T17:00`, 
            type: 'kids',
        },
        { 
            title: '유치부(7세)',
            startDate: `${weekArr[3].slice(0, 10)}T17:00`, 
            endDate: `${weekArr[3].slice(0, 10)}T18:00`, 
            type: 'kids',
        },
        { 
            title: '선수반 | 대표반',
            startDate: `${weekArr[3].slice(0, 10)}T17:00`, 
            endDate: `${weekArr[3].slice(0, 10)}T19:00`,
            type: 'athelet',
        },
    ];

    const thu_class = [
        { 
            title: '초등부 (1학년)',
            startDate: `${weekArr[4].slice(0, 10)}T14:00`, 
            endDate: `${weekArr[4].slice(0, 10)}T15:00`, 
            type: 'elementry_low',
        },
        { 
            title: '초등부 (2, 3학년)',
            startDate: `${weekArr[4].slice(0, 10)}T15:00`, 
            endDate: `${weekArr[4].slice(0, 10)}T16:00`, 
            type: 'elementry_low',
        },
        { 
            title: '유치부(6, 7세)',
            startDate: `${weekArr[4].slice(0, 10)}T16:00`, 
            endDate: `${weekArr[4].slice(0, 10)}T17:00`, 
            type: 'kids',
        },
        { 
            title: '유치부(7세)',
            startDate: `${weekArr[4].slice(0, 10)}T17:00`, 
            endDate: `${weekArr[4].slice(0, 10)}T18:00`, 
            type: 'kids',
        },
        { 
            title: '선수반 | 대표반',
            startDate: `${weekArr[4].slice(0, 10)}T17:00`, 
            endDate: `${weekArr[4].slice(0, 10)}T19:00`, 
            type: 'athelet',
        },
    ];

    const fri_class = [
        { 
            title: '초등부 (1학년)',
            startDate: `${weekArr[5]}T14:00`, 
            endDate: `${weekArr[5]}T15:00`,
            type: 'elementry_low',
        },
        { 
            title: '초등부 (2, 3학년)',
            startDate: `${weekArr[5].slice(0, 10)}T15:00`, 
            endDate: `${weekArr[5].slice(0, 10)}T16:00`, 
            type: 'elementry_low',
        },
        { 
            title: '유치부(6, 7세)',
            startDate: `${weekArr[5].slice(0, 10)}T16:00`, 
            endDate: `${weekArr[5].slice(0, 10)}T17:00`, 
            type: 'kids',
        },
        { 
            title: '유치부(7세)',
            startDate: `${weekArr[5].slice(0, 10)}T17:00`, 
            endDate: `${weekArr[5].slice(0, 10)}T18:00`, 
            type: 'kids',
        },
        { 
            title: '선수반 | 대표반',
            startDate: `${weekArr[5].slice(0, 10)}T17:00`, 
            endDate: `${weekArr[5].slice(0, 10)}T19:00`, 
            type: 'athelet',
        },
    ];

    // 최종 export 할 배열 생성
    let finalArr: any = [];
    // console.log(finalArr)
    mon_class.map((el) => finalArr.push(el));
    tue_class.map((el) => finalArr.push(el));
    wed_class.map((el) => finalArr.push(el));
    thu_class.map((el) => finalArr.push(el));
    fri_class.map((el) => finalArr.push(el));

export default finalArr;